// extracted by mini-css-extract-plugin
module.exports = {"vantageBlue":"#3f1f5a","icon":"CohortStatus_icon__3lcoD","green":"CohortStatus_green__24cEf","stop":"CohortStatus_stop__1fN79"};